import React from 'react';
import { Navbar } from './Navbar';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-24">
      <Navbar data-id="element-25" />
      <main className="flex-1" data-id="element-26">{children}</main>
    </div>;
}